import * as React from 'react';
const useDismissibleErrors = (setStoredErrors, capacity) => {
    const promiseWrapper = promise => promise
        .catch((err) => {
        const id = Math.random().toString();
        const newStoredError = {
            id,
            dismissible: true,
            actionDisabled: false,
            error: err,
            action: () => setStoredErrors(storedErrors => storedErrors.filter(e => e.id !== id))
        };
        setStoredErrors(storedErrors => {
            const oldDismissibleErrors = storedErrors.filter(e => e.dismissible);
            return [newStoredError].concat(storedErrors.filter(e => !e.dismissible || oldDismissibleErrors.findIndex(ode => ode.id === e.id) < capacity - 1));
        });
        throw err;
    });
    return promiseWrapper;
};
export const useNonDismissibleErrors = (setStoredErrors, errorCategory) => {
    const [retryCounter, setReloadCounter] = React.useState(0);
    const promiseWrapper = promise => promise
        .then(result => {
        setStoredErrors(storedErrors => storedErrors.filter(e => e.id !== errorCategory));
        return result;
    })
        .catch((err) => {
        setStoredErrors(storedErrors => {
            if (!storedErrors.some(e => e.id === errorCategory)) {
                const newStoredError = {
                    id: errorCategory,
                    dismissible: false,
                    actionDisabled: false,
                    error: err,
                    action() {
                        setStoredErrors(_storedErrors => _storedErrors.map(e => {
                            if (e.id !== errorCategory) {
                                return e;
                            }
                            e.actionDisabled = true;
                            return e;
                        }));
                        setReloadCounter(_retryCounter => _retryCounter + 1);
                    }
                };
                return [newStoredError].concat(storedErrors);
            }
            return storedErrors.map(e => {
                if (e.id !== errorCategory) {
                    return e;
                }
                e.actionDisabled = false;
                return e;
            });
        });
        throw err;
    });
    return [promiseWrapper, retryCounter];
};
export const useStoredErrors = capacity => {
    const [storedErrors, setStoredErrors] = React.useState([]);
    const catchDismissibleError = useDismissibleErrors(setStoredErrors, capacity);
    return [storedErrors, setStoredErrors, catchDismissibleError];
};
//# sourceMappingURL=useStoredError.js.map